import { InvalidStateError } from '@stacks/common';

var SESSION_VERSION = '1.0.0';
var SessionData = /*#__PURE__*/function () {
  function SessionData(options) {
    this.version = SESSION_VERSION;
    this.userData = options.userData;
    this.transitKey = options.transitKey;
    this.etags = options.etags ? options.etags : {};
  }

  SessionData.fromJSON = function fromJSON(json) {
    if (json.version !== SESSION_VERSION) {
      throw new InvalidStateError("JSON data version " + json.version + " not supported by SessionData");
    }

    var options = {
      coreNode: json.coreNode,
      userData: json.userData,
      transitKey: json.transitKey,
      etags: json.etags
    };
    return new SessionData(options);
  };

  var _proto = SessionData.prototype;

  _proto.toString = function toString() {
    return JSON.stringify(this);
  };

  return SessionData;
}();

export { SessionData };
//# sourceMappingURL=sessionData.esm.js.map
